<template>
    <div class="list-page">
        <transition name="fade" mode="out-in">
            <div v-if="show" key="list">
                <el-form
                    :inline="true"
                    :model="formInline"
                    ref="formInline"
                    class="demo-form-inline"
                    size="mini"
                    @submit.native.prevent="onSubmit"
                >
                    <el-form-item  prop="task_id">
                        <CustomInput label="任务ID">
                             <el-input
                                v-model="formInline.task_id"
                                placeholder="任务ID"
                                style="width: 100px"
                                clearable
                                @keyup.enter.native="onSubmit"
                            ></el-input>
                        </CustomInput>
                    </el-form-item>
                    <el-form-item  prop="account_id">
                        <CustomInput label="账户">
                            <ESelect
                                v-model="formInline.account_id"
                                placeholder="账户名称关键字或用户名搜索"
                                style="width: 260px"
                                class="tagswidth"
                                multiple
                                collapse-tags
                                clearable
                                filterable
                                remote
                                :remote-method="(query)=>remoteMethod(query, 'account')"
                            >
                                <el-option
                                    v-for="item in account"
                                    :key="item.id"
                                    :label="item.name+item.id"
                                    :value="item.id">
                                    <span style="float: left">{{ item.name }}</span>
                                </el-option>
                            </ESelect>
                        </CustomInput>
                        
                    </el-form-item>
                    <el-form-item  prop="source_plan_id">
                         <CustomInput label="计划">
                            <ESelect
                                v-model="formInline.source_plan_id"
                                placeholder="计划名称关键字或者计划ID搜索"
                                style="width: 260px"
                                class="tagswidth"
                                multiple
                                collapse-tags
                                clearable
                                filterable
                                remote
                                :remote-method="(query)=>remoteMethod(query, 'plan')"
                            >
                            <el-option
                                v-for="item in plan"
                                :key="item.id"
                                :label="item.name+'('+item.id+')'"
                                :value="item.id">
                                <span style="float: left">{{ item.name }}（{{item.id}}）</span>
                            </el-option>
                            </ESelect>
                         </CustomInput>
                    </el-form-item>
                    <el-form-item  prop="package_name">
                         <CustomInput label="产品">
                            <ESelect
                                v-model="formInline.package_name"
                                placeholder="产品名称、ID、包名精准搜索"
                                style="width: 260px"
                                class="tagswidth"
                                multiple
                                collapse-tags
                                clearable
                                filterable
                                remote
                                :remote-method="(query)=>remoteMethod(query, 'app')"
                            >
                                <el-option
                                    v-for="item in app"
                                    :key="item.app_id+item.app_package_name"
                                    :label="item.app_name+'('+item.app_id+')'+'('+item.app_package_name+')'"
                                    :value="item.app_package_name">
                                    <span style="float: left">{{ item.app_name }}（{{item.app_id}}）（{{item.app_package_name}}）</span>
                                </el-option>
                            </ESelect>
                         </CustomInput>
                        
                    </el-form-item>
                     <el-form-item  prop="media_type">
                         <CustomInput label="计划类型">
                            <ESelect
                                v-model="formInline.media_type"
                                placeholder="支持名称关键字搜索"
                                style="width: 160px"
                                clearable
                                filterable
                                @focus="()=>handleFouce('media_type')"
                            >
                            <el-option
                                v-for="item in media_type"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                            </ESelect>
                         </CustomInput>
                    </el-form-item>
                    
                    <el-form-item  prop="creator">
                         <CustomInput label="创建人">
                             <ESelect
                                v-model="formInline.creator"
                                placeholder="支持名称关键字搜索"
                                style="width: 160px"
                                multiple
                                collapse-tags
                                clearable
                                filterable
                                @focus="()=>handleFouce('creator')"
                            >
                            <el-option
                                v-for="item in creator"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                            </ESelect>
                         </CustomInput>
                       
                    </el-form-item>
                    <el-form-item  prop="department" v-show="isHasCreateDepartment">
                        <CustomInput label="创建部门">
                            <ESelect
                                v-model="formInline.department"
                                placeholder="支持名称关键字搜索"
                                style="width: 180px"
                                clearable
                                filterable
                                multiple
                                collapse-tags
                                @focus="()=>handleFouce('department')"
                            >
                                <el-option
                                    v-for="item in department"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </ESelect>
                        </CustomInput>
                    </el-form-item>
                    <el-form-item prop="range_time">
                        <CustomInput label="创建时间">
                            <el-date-picker
                                v-model="range_time"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="basePickerOptions"
                                value-format="yyyy-MM-dd"
                                :clearable="false"
                                style="width: 240px"
                                >
                            </el-date-picker>
                        </CustomInput>
                    </el-form-item>
                    <el-form-item  prop="status">
                        <CustomInput label="任务状态">
                            <ESelect
                                v-model="formInline.status"
                                placeholder="任务状态"
                                style="width: 180px"
                                multiple
                                collapse-tags
                                clearable
                            >
                                <el-option
                                    label="创建中"
                                    value="1"
                                ></el-option>
                                <el-option
                                    label="创建成功"
                                    value="2"
                                ></el-option>
                                <el-option
                                    label="创建失败"
                                    value="3"
                                ></el-option>
                                <el-option
                                    label="部分创建失败"
                                    value="4"
                                ></el-option>
                            </ESelect>
                        </CustomInput>
                    </el-form-item>
                    <el-form-item  prop="target_account_id">
                        <CustomInput label="目标账户">
                            <ESelect
                                v-model="formInline.target_account_id"
                                placeholder="账户名称关键字或用户名搜索"
                                style="width: 260px"
                                class="tagswidth"
                                multiple
                                collapse-tags
                                clearable
                                filterable
                                remote
                                :remote-method="(query)=>remoteMethod(query, 'target_account')"
                            >
                                <el-option
                                    v-for="item in targetAccount"
                                    :key="item.id"
                                    :label="item.name+item.id"
                                    :value="item.id">
                                    <span style="float: left">{{ item.name }}</span>
                                </el-option>
                            </ESelect>
                        </CustomInput>
                        
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="onSubmit" :loading="loading"  v-matomo="{behaviorCategory: 'vivo(批量创建)',  name: '筛选(查询)' }"
                            >筛选</el-button
                        >
                        <el-button @click="resetForm('formInline')" v-matomo="{behaviorCategory: 'vivo(批量创建)',  name: '筛选(重置筛选)' }"
                            >重置筛选</el-button
                        >
                    </el-form-item>
                </el-form>

                <el-button
                    v-if="isHasBatchCreate"
                    type="primary"
                    @click="toConfigPage"
                    size="mini"
                    style="margin-bottom: 20px"
                    v-matomo="{behaviorCategory: 'vivo(批量创建)',  name: '批量创建' }"
                    >批量创建</el-button
                >
                <JtTable
                    :data="tableData"
                    style="width: 100%"
                    stripe
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    size="mini"
                    class="create_vivo_list"
                    :row-class-name="tableRowClassName"
                    v-loading="loading"
                    tooltip-effect="dark"
                >
                    <el-table-column label="任务ID" width="80" prop="id">
                        <template slot-scope="scope">
                            <span v-if="scope.row.id">{{ scope.row.id }}</span>
                            <span v-else>汇总</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="账户&调用计划" min-width="240" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div v-if="scope.$index != 0">
                                <p class="ellipsis">账户:{{scope.row.account_name}}({{scope.row.user_name}})</p>
                                <br/>
                                <p class="ellipsis">计划:{{scope.row.plan_name}} ({{scope.row.plan_id}})</p>
                            </div>
                            <span v-else>
                                账户：{{scope.row.account_distinct_num}}/{{scope.row.account_num}}；
                                计划：{{scope.row.plan_distinct_num}}/{{scope.row.plan_num}}；
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="投放产品" prop="type" min-width="300">
                        <template slot-scope="scope">
                            <div v-if="scope.$index != 0">
                                <div v-for="item in scope.row.app||[]">
                                    <p class="text-nowrap">{{item.app_name||'--'}}({{item.app_id||'--'}})({{item.package_name}})</p>
                                </div>
                            </div>
                            <span v-else>
                                {{scope.row.app_distinct_num}}/{{scope.row.app_num}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="计划类型" min-width="140px" prop="media_type_text">
                        <template slot-scope="scope">
                            <span  v-if="scope.$index != 0">{{ scope.row.media_type_text}}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="创建计划规格(成功数量/总量)"
                        min-width="360"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <div>
                                <p class="ellipsis">计划(<span class="text-color-success">{{ scope.row.success_plan_num }}</span>/<span>{{ scope.row.total_plan_num }}</span>)；广告组(<span class="text-color-success">{{ scope.row.success_adgroup_num }}</span>/<span>{{ scope.row.total_adgroup_num }}</span>)；广告(<span class="text-color-success">{{ scope.row.success_ad_num }}</span>/<span>{{ scope.row.total_ad_num }}</span>)；创意(<span class="text-color-success">{{ scope.row.success_idea_num }}</span>/<span>{{ scope.row.total_idea_num }}</span>)</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="目标账户" min-width="80">
                        <template slot-scope="scope">
                            <span v-if="scope.$index != 0" style="color: #409eff; cursor: pointer;" @click="handleAccount(scope.$index, scope.row)">{{ scope.row.account_num }}</span>
                            <span v-else>{{scope.row.target_account_distinct_num}}/{{scope.row.target_account_num}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="任务状态" min-width="80">
                        <template slot-scope="scope">
                            <div v-if="scope.$index != 0">
                                <!-- 1-创建中，2-成功，3-失败，4-部分失败  -->
                                <p v-if="scope.row.status == 1" style="color: #409eff;">{{ scope.row.status_text}}<i class="el-icon-loading"></i></p>
                                <p v-else-if="scope.row.status == 2" class="text-color-success">{{ scope.row.status_text}}</p>
                                <div v-else class="text-color-error text-nowrap">
                                    <el-tooltip class="item" effect="dark"  placement="top" v-if="scope.row.err_msg">
                                        <div slot="content">
                                            <p class="mb6">您可点击任务详情查看具体失败计划，失败原因如下：</p>
                                            <div v-html="scope.row.err_msg.replace(/\\n/g, '<br/>')"></div>
                                        </div>
                                        <span class="pointer">{{ scope.row.status_text}}<i class="el-icon-warning-outline"></i></span>
                                    </el-tooltip>
                                    <span v-else>{{ scope.row.status_text}}</span>
                                </div>
                            </div>
                            <span v-else>-</span>
                        </template>

                     <!--   <template slot-scope="scope">
                            <div v-if="scope.$index != 0">
                                <p v-if="scope.row.status == 1" style="color: #409eff;">{{ scope.row.status_text}}<i class="el-icon-loading"></i></p>
                                <p v-else-if="scope.row.status == 2" class="text-color-success">{{ scope.row.status_text}}</p>
                                <p v-else-if="scope.row.status == 3" class="text-color-error">{{ scope.row.status_text}}</p>
                                <p v-else-if="scope.row.status == 4" class="text-color-error">{{ scope.row.status_text}}</p>
                            </div>
                            <span v-else>—</span>
                        </template>-->
                    </el-table-column>
                    <el-table-column label="创建人" min-width="80" prop="name">
                        <template slot-scope="scope">
                            <span v-if="scope.$index != 0">{{ scope.row.name }}</span>
                            <span v-else>{{scope.row.creator_distinct_num}}/{{scope.row.creator_num}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间" width="90">
                        <template slot-scope="scope">
                            <span v-if="scope.$index != 0">{{ scope.row.ctime }}</span>
                            <span v-else>—</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="140" fixed="right">
                        <template slot-scope="scope" v-if="scope.$index != 0" >
                            <el-button size="mini" type="text" @click="handleClick(scope.$index, scope.row)" v-matomo="{behaviorCategory: 'vivo(列表)',  name: '任务详情' }">任务详情</el-button>
                            <el-button size="mini" type="text" @click="handleRetry(scope.$index, scope.row)" :disabled="!scope.row.status||scope.row.status=='1'||scope.row.status=='2'" :loading="scope.row.retryLoading" v-matomo="{behaviorCategory: 'vivo(列表)',  name: '重试' }">重试</el-button>
                        </template>
                    </el-table-column>
                </JtTable>

                <div style="text-align: right; padding-top: 20px">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[ 30, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    >
                    </el-pagination>
                </div>

                <el-dialog
                    title="目标账户"
                    :visible.sync="dialogVisible"
                    width="30%"
                    :destroy-on-close="true"
                >
                    <p v-for="(item, index) in accountInfo" :key="index">{{ item.account_name }}-{{ item.user_name }}</p>
                    <!-- <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false"
                            >取 消</el-button
                        >
                        <el-button type="primary" @click="dialogVisible = false"
                            >确 定</el-button
                        >
                    </span> -->
                </el-dialog>
            </div>
            <div v-else key="info">
                <InfoPage :id="msg" :isAimedia="isAimedia" @goback="handleGoback"/>
            </div>
        </transition>
    </div>
</template>

<script>
import InfoPage from "./infoPage.vue"
import {GET_SEARCH_LIST, GET_TOTAL, GET_LIST, GET_TARGET_ACCOUNT,TASK_RETRY} from "@/api/create-vivo.js"
import dayjs from "dayjs";
import CustomInput from '@/components/CustomInput'
import { JtTable } from '@/components/Ele'
export default {
    name: "ListPage",
    props:{
        pageFuncNames:Array,
        pageDimensionNames:Array,
    },
    components: {
        InfoPage,
        CustomInput,
        JtTable
    },
    data() {
        const id = this.$route.query.id || "";
        console.log(id, 'ididididid');
        
        return {
            show: true,
            msg:'',
            formInline: {
                task_id: id,        //任务ID
                account_id: "",     //账户ID
                target_account_id: "",     //目标账户ID
                source_plan_id:"",  //计划
                package_name:"",  //产品
                creator: "",        //创始人
                department: "",     //创始部门
                status:"",           //任务状态
                media_type:""           //计划类型
                
            },
            range_time:"",      //创建时间
            account: [],            //select搜索
            targetAccount: [],            //select搜索
            plan: [],            //select搜索
            app:[],            //select搜索
            creator: [],            //select搜索
            department: [],            //select搜索
            media_type: [],            //select搜索
            loading:true,
            currentPage: 1,
            pageSize: 30,
            total: 10,
            monitor:null, //定时器
            equal: 1, //缓存请求赋值
            status_err:[],
            tableData: [],
            dialogVisible: false,
            accountInfo:[],
            basePickerOptions: {
                firstDayOfWeek: 1,
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [
                        {
                            text: '最近7天',
                            onClick(picker) {
                                const date = new Date();
                                let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 7);
                                let endDate = new Date(date.getTime());
                                picker.$emit('pick', [startDate,endDate]);
                            }
                        },
                        {
                            text: '上周',
                            onClick(picker) {
                                // 上周：自然周，周一到周日
                                let date = new Date(new Date().getTime()-1000*60*60*24*7);
                                let weekDay = date.getDay();
                                let startDate = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
                                let endDate = new Date(startDate.getTime() + 1000*60*60*24*6);
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate = year+'-'+month+'-1';
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '上月',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth();
                                let startDate = new Date(year+'-'+month+'-01');
                                let endDate = new Date(new Date(year+'-'+(month+1)+'-01').getTime()-1000*60*60*24);
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本季度',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate='';
                                if([1,2,3].includes(month)){
                                    startDate = year+'-01-01';
                                }else if([4,5,6].includes(month)){
                                    startDate = year+'-04-01';
                                }else if([7,8,9].includes(month)){
                                    startDate = year+'-07-01';
                                }else if([10,11,12].includes(month)){
                                    startDate = year+'-10-01';
                                }
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                        text: '上季度',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth()+1;

                            let startDate='';
                            let endDate = '';
                            if([1,2,3].includes(month)){
                                startDate = (year-1)+'-10-01';
                                endDate = (year-1)+'-12-31';
                            }else if([4,5,6].includes(month)){
                                startDate = year+'-01-01';
                                endDate = year+'-03-31';
                            }else if([7,8,9].includes(month)){
                                startDate = year+'-04-01';
                                endDate = year+'-06-30';
                            }else if([10,11,12].includes(month)){
                                startDate = year+'-07-01';
                                endDate = year+'-09-30';
                            }
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '今年',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let startDate= year+'-01-01';
                            let endDate = year+'-12-31';
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '去年',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear()-1;
                            let startDate= year+'-01-01';
                            let endDate = year+'-12-31';
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    }
                    ]
                },
            isAimedia: false,
        }
    },
    computed:{
        isHasCreateDepartment(){
            return this.pageDimensionNames.includes('create_department');
        },
        isHasBatchCreate(){
            return this.pageFuncNames.includes('vivo_batch_create');
        }
    },
    mounted() {
        this.renovate()
    },
    methods: {
        renovate() {
            // this.resetForm('formInline')
            let arr = this.isHasCreateDepartment ? ['creator', 'department', 'media_type'] : ['creator', 'media_type']
            arr.forEach(item=>{
                GET_SEARCH_LIST({search_type:item}).then(res=>{
                    let result = res.data
                    this[item] = result
                })
            })
            let startDate = dayjs().subtract(6,'day').format("YYYY-MM-DD");
            let endDate = dayjs().format("YYYY-MM-DD");
            this.range_time = [startDate, endDate]
            this.inin()
        },
        handleFouce(type) {
            GET_SEARCH_LIST({search_type:type}).then(res=>{
                let result = res.data
                this[type] = result
            })
        },
        toConfigPage() {
            this.handleKill()
            this.$emit("changePage", "config")
        },
        tableRowClassName({row, rowIndex}) {
            if (rowIndex === 0) {
                return 'gray-row';
            }
            return '';
        },
        remoteMethod(query, type) {
            console.log('remoteMethod',query,type)
            if(!query) return;
            GET_SEARCH_LIST({search_type:type, query: query}).then(res=>{
                let result = res.data
                this[type=='target_account'?'targetAccount':type] = result
            })
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            this.inin()
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
            this.inin()
        },
        handleChange(type) {
            GET_SEARCH_LIST({search_type:type}).then(res=>{
                let result = res.data
                this[type] = result
            })
        },
        onSubmit() {
            this.handleKill()
            this.currentPage = 1
            this.inin()
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
            this.formInline.task_id = ''
            this.formInline.account_id = ''
            this.formInline.target_account_id = ''
            this.formInline.source_plan_id = ''
            this.formInline.package_name = ''
            this.formInline.creator = ''
            this.formInline.department = ''
            this.formInline.status = ''
            this.formInline.media_type = ''
            this.currentPage = 1
            this.$nextTick(()=>{
                this.inin()
            })
        },
        // 目标账户
        handleAccount(inex, row) {
            GET_TARGET_ACCOUNT({task_id:row.task_id}).then(res=>{
                let result = res.data
                this.accountInfo = result
            })
            this.dialogVisible = true
        },
        // 任务详情
        handleClick(index, row) {
            this.handleKill()
            this.delayedClear()
            this.show = false
            this.msg = row.id;
            this.isAimedia = row.media_type === '15'
            this.$emit('infoPage',!this.show);
        },
        handleRetry(index, row){
            console.log('handleRetry',index,row);
            // taskRetry
            row.retryLoading = true;
            TASK_RETRY({
                task_id: row.id
            }).then(res=>{
                row.retryLoading = false;
                this.$message.success(res.info||'操作成功');
                this.inin();
            },err=>{
                row.retryLoading = false;
                if (err.code == '403') {
                    if(this.confirmTip) return;
                    this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                        confirmButtonText: '刷新',
                        type: 'warning',
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        window.location.reload()
                        this.confirmTip = null;
                    }).catch(() => {
                        this.confirmTip = null;
                    });
                    return
                }
                this.$message.error(err.info||'操作异常');
            })
        },
        handleGoback() {
            this.handleKill()
            this.show = true
            this.inin()
            this.$emit('infoPage',!this.show);
        },
        handleClose(done) {

        },
        inin() {
            // this.handleKill()
            // let obj = {...this.formInline, pn: this.currentPage, rn: this.pageSize, range_time:this.range_time.join('/')}
            // obj.department = this.isHasCreateDepartment? obj.department:'';
            this.loading = true
            this.polling()
        },
        polling() {
            let params = {...this.formInline, pn: this.currentPage, rn: this.pageSize, range_time:this.range_time.join('/')}
            params.department = this.isHasCreateDepartment? params.department:'';
            GET_TOTAL(params).then(totalList=>{
                let tlist = totalList.data
                GET_LIST(params).then(res=>{
                    let result = res.data
                    let tableList = [tlist, ...result.list.map(item=>{
                        item.retryLoading = false;
                        return item;
                    })]
                    this.loading = false

                    let createarr = []
                    result.list.forEach(element => {
                        if(element.status == 1) {
                            createarr.push(element.id)
                        }
                    });
                    clearTimeout(this.monitor)
                    this.monitor = null

                    this.tableData = tableList
                    this.currentPage = result.pageNum
                    this.pageSize = result.pageSize
                    this.total = result.totalCnt
                    if(createarr.length != 0) {
                        // let obj = {...this.formInline, pn: this.currentPage, rn: this.pageSize, range_time:this.range_time.join('/')}
                        // obj.department = this.isHasCreateDepartment? obj.department:'';
                        // this.monitor = setTimeout(()=>{this.polling()}, 5000)
                    }else{
                        this.handleKill()
                    }

                })
            },err=>{
                this.loading = false;
                if (err.code == '403') {
                    if(this.confirmTip) return;
                    this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                        confirmButtonText: '刷新',
                        type: 'warning',
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        window.location.reload()
                        this.confirmTip = null;
                    }).catch(() => {
                        this.confirmTip = null;
                    });
                    return
                }
                this.$message.error(err.info)
            })
        },
        handleKill() {
            for(let i=1; i<10; i++) {
                clearTimeout(this.monitor)
                this.monitor = null
                this.equal = 1
            }
        },
        delayedClear() {
            setTimeout(()=>{
                for(let i=1; i<10; i++) {
                    clearTimeout(this.monitor)
                    this.monitor = null
                    this.equal = 1
                }
            }, 5000)
        }
    },
    deactivated() {
        this.$nextTick(()=>{
            this.handleKill()
            this.delayedClear()
        })
    },
    beforeDestroy() {
        this.handleKill()
        this.delayedClear()
    },
    destroyed() {
        this.handleKill()
        this.delayedClear()
    }
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
.list-page ::v-deep.el-table .gray-row{
    background-color: #f4f4f4;
}
.ellipsis{
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}
.create_vivo_list tbody .cell div{
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}

.demo-form-inline{
    padding: 20px 20px 0;
    background: #f8f8f9;
    margin-bottom: 20px;
}

</style>
<style>
.tagswidth.el-select .el-tag {
    max-width: 70%;
}
</style>
